<template lang="pug">
    //- Keyboard: Delete has the focus (Enter confirms), Esc cancels, Tab stays inside.
    el-dialog(
        v-focus-trap="visible"
        :title="currentTitle"
        :visible.sync="visible"
        :before-close="cancel"
        :close-on-click-modal="false"
        append-to-body
        top="15vh"
        width="420px"
    )
        p.confirm-delete-dialog__message {{ currentMessage }}
        template(slot="footer")
            .confirm-delete-dialog__footer
                el-checkbox(v-model="remember") {{ $t("Don't keep asking") }}
                .confirm-delete-dialog__actions
                    el-button(size="mini" icon="el-icon-fa-times fas" @click="cancel") {{ $t('Cancel') }}
                    el-button(size="mini" type="danger" icon="el-icon-fa-trash fas" data-autofocus @click="confirm") {{ confirmLabel || $t('Delete') }}
</template>

<i18n>
{
    "de": {
        "Don't keep asking": "Nicht erneut fragen",
        "Cancel": "Abbrechen",
        "Delete": "Löschen"
    }
}
</i18n>

<script>
// The project's standard delete confirmation: a modal (not a popover) with a "Don't keep
// asking" checkbox that, once ticked, skips the dialog for the rest of the session. Mirrors
// the Property form's clear-unlinked dialog, extracted so every delete reuses one surface.
//
// Usage: keep one instance per delete kind, trigger it from the delete control, and do the
// deletion in @confirm:
//   el-button(@click="$refs.deleteDialog.open(item)")
//   confirm-delete-dialog(ref="deleteDialog" :title="..." :message="..." @confirm="remove")
export default {
    name: 'ConfirmDeleteDialog',
    props: {
        title: { type: String, default: '' },
        message: { type: String, default: '' },
        // Override the primary button label (defaults to "Delete").
        confirmLabel: { type: String, default: '' }
    },
    data() {
        return {
            visible: false,
            remember: false,
            payload: null,
            currentTitle: '',
            currentMessage: ''
        }
    },
    methods: {
        // Open for a target. `overrides` lets one instance serve several rows with a
        // per-open title/message. If the user chose "Don't keep asking" this session, the
        // deletion is confirmed immediately without showing the dialog.
        open(payload = null, overrides = {}) {
            this.payload = payload
            this.currentTitle = overrides.title || this.title
            this.currentMessage = overrides.message || this.message
            if (this.remember) {
                this.$emit('confirm', payload)
                return
            }
            this.visible = true
        },
        confirm() {
            this.visible = false
            this.$emit('confirm', this.payload)
        },
        cancel() {
            this.visible = false
        }
    }
}
</script>

<style lang="sass" scoped>
.confirm-delete-dialog__message
    margin: 0
    line-height: 1.5
    color: #606266
.confirm-delete-dialog__footer
    display: flex
    align-items: center
    justify-content: space-between
    gap: 12px
    .confirm-delete-dialog__actions
        display: flex
        gap: 8px
</style>
